import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'faculty-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './faculty-menu.component.html',
  styleUrls: ['./faculty-menu.component.css'],
})
export class FacultyMenuComponent {

}
